// removed by extract-text-webpack-plugin
module.exports = {"label":"RadioOptionLabel__label___L1DeU"};